<template>
  <div
    class="
      flex
      flex-row
      h-full
      items-center
      justify-center
      px-7
      py-52
      sm:flex-col
      sm:py-16
      w-full
    "
  >
    <img
      :src="imgSrc"
      alt="Mail link outdated"
    />
    <div class="
      flex
      flex-col
      justify-center
      ml-25
      mt-0
      sm:items-center
      sm:ml-0
      sm:mt-11
      sm:w-full
      max-w-[336px]
    ">
      <h1 class="font-light text-primary-500 text-3xl mb-6">
        驗證連結已逾期
      </h1>
      <p class="sm:text-[14px] text-black text-sm">
        邀請信件已逾期，請聯繫管理員，重發邀請信。
      </p>
    </div>
  </div>
</template>

<script>
import LinkOutdated from './LinkOutdated';

export default LinkOutdated;
</script>

<style lang="scss" scoped>
@import 'LinkOutdated';
</style>
